/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosError } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { Api } from '../axiosApi';

export interface IListagemContasReceber {
  idrec: string;
  emissao: Date;
  vencimento: Date;
  numero: string;
  venda: number;
  logo:string;
  vrecebido: number;
  desconto: number;
  acrescimo: number;
  parceiros: string;
  vparcela: number;
  marcado: boolean;
  vreceber: number
}
export interface IMarcados{
  idrec: string;
	marcado: boolean;
	desconto: number;
	vreceber: number;
}
export interface ICheque{
  idcheque: string;
  banco: string;
  agencia: string;
  conta: string;
  datadeposito: Date;
  titular: string;
  valor: number;
  numero: string;
}
type TotalCount = {
    data: IListagemContasReceber[];
    totalCount: number;
    selecionado: number;
    total: number;
}
interface IRecebidos {
  recebido: number;
  total: number;
  idconta: string;
  datacaixa: Date;
  tipocaixa: boolean;
}
export interface IContasaReceber {
  idparceiro: string;
  idplanoconta: string;
  vencimento: Date;
  emissao: Date;
  parcela?: string;
  numero?: string;
  venda: number;
  vparcela: number;
  vrecebido: number;
  acrescimo: number;
  juros: number;
  desconto: number;
  vreceber: number;
}
export interface IContasaReceberUpdate {
  idparceiro: string;
  idplanoconta: string;
  vencimento: Date;
  emissao: Date;
  parcela?: string;
  numero?: string;
  venda: number;
  vparcela: number;
  vrecebido: number;
  acrescimo: number;
  juros: number;
  desconto: number;
  vreceber: number;
  recebido: number;
}
interface IGetReceber {
 idparceiro: string;
  idplanoconta: string;
  vencimento: Date;
  emissao: Date;
  parcela?: string;
  numero?: string;
  venda: number;
  vparcela: number;
  vrecebido: number;
  acrescimo: number;
  juros: number;
  desconto: number;
  vreceber: number;
  recebido: number;
  tipo: number;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}

const create = async (dados: IContasaReceber): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const tipo = 2;
    const { data } = await Api.post<IContasaReceber>('/contasreceber',  {idrec: guuid, tipo: tipo,  ...dados});
  
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, dados: IContasaReceberUpdate): Promise<void | Error> => {
  try {

    await Api.put(`/contasreceber/${id}`, dados);

  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const getAll = async (page = 1, filter = '', tipo = '', datai = '', dataf = ''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/contasreceber?page=${page}&limit=${300}&filter=${filter}&tipo=${tipo}&datai=${datai}&dataf=${dataf}`;
    const { data, headers } = await Api.get(urlRelativa);  
   
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count']|| 0),
        selecionado: Number(headers['x-total-selecionado'] || 0),
        total: Number(headers['x-total-valor'] || 0),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const Marcados = async (dados: IMarcados[]): Promise<void | Error> => {
  try {
    await Api.post('/recebermarcado', dados);    
    return;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const Baixa = async (dados: IRecebidos, receber: IListagemContasReceber[]): Promise<void | Error> => {
  try { 
    let historicos = '';  
    if(dados.recebido === dados.total){
      const baixa = receber.map(conta => {   
        historicos += `${conta.numero}, `;
        return {
          idrec: conta.idrec,
          idconta: dados.idconta,
          datacaixa: dados.datacaixa,
          recebido: dados.recebido,
          historico: `Recebimento dos numeros ${historicos.slice(0, -2)}`,
          tipocaixa: dados.tipocaixa,
          total: dados.total,
        };
      });
      await Api.post('/receberbaixa', baixa); 
      return;
    }else{
      const baixa = receber.map(conta => {
        return {
          idrec: conta.idrec,
          idconta: dados.idconta,
          datacaixa: dados.datacaixa,
          dataoperacao: dados.datacaixa,
          recebido: dados.recebido,
          tipocaixa: dados.tipocaixa,
          total: dados.total,
        };
      });
      await Api.post('/receberbaixaparcial', baixa); 
      return;   
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const BaixaCheque = async (dados: Omit<IRecebidos, 'idconta' | 'tipocaixa'>, receber: IListagemContasReceber[], cheque: ICheque[]): Promise<void | Error> => {
  try {  
    if(dados.recebido === dados.total){
      const baixa = receber.map(conta => {
        return {
          idreceber: conta.idrec,
          dataoperacao: dados.datacaixa,
          recebido: conta.vreceber,
          historico: '',
          tipocaixa: true,
          total: dados.total,
        };
      });
      await Api.post('/receberbaixacheque',  [baixa, cheque]); 
      return;
    }else{
      const baixa = receber.map(conta => {
        return {
          idreceber: conta.idrec,
          datacaixa: dados.datacaixa,
          recebido: dados.recebido,
          valornfe: 0,
          historico: '',
          tipocaixa: true,
          total: dados.total,
        };
      });
      await Api.post('/receberbaixachequeparcial', [baixa, cheque]); 
      return;   
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getById = async (id: string): Promise<IGetReceber | Error> => {
  try {
    const { data } = await Api.get(`/contasreceber/${id}`);
    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/contasreceber/${id}`);
  }catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const ContasReceberService = {  
  getAll,
  Marcados,
  Baixa,
  BaixaCheque,
  create,
  updateById,
  getById,
  deleteById,
};